import { requestServerApi, serverApi } from '../api/api';
import { devConfig, settingForDemo } from '../config/dev';
import { IS_DEMO } from '../config/env-config';
import { ZoomClient } from '../index-types';
import { Lesson } from './lesson-service';
import { UserInfo } from './user-service';

interface IJoinService {
  joinRoom(userInfo: UserInfo, lessonInfo: Lesson, zmClient: ZoomClient): Promise<void>;
}
class JoinServiceApp implements IJoinService {
  async joinRoom(userInfo: UserInfo, lessonInfo: Lesson, zmClient: ZoomClient): Promise<void> {
    if (!userInfo) {
      return;
    }
    if (!lessonInfo) {
      return;
    }
    const session = zmClient.getSessionInfo();
    if (session && session.isInMeeting) {
      return;
    }
    const tokenResponse = await requestServerApi<any>(() =>
      serverApi.organizationsControllerGetZoomToken(lessonInfo.roomId)
    );
    const resultData = tokenResponse?.data?.data;
    if (!Array.isArray(resultData)) {
      throw new Error();
    }
    if (resultData.length === 0) {
      throw new Error();
    }

    await zmClient.join(lessonInfo.roomId, resultData[0]?.token, userInfo.nickName, '').catch((e) => {
      console.log(e);
    });
  }
}

class JoinServiceDemo implements IJoinService {
  async joinRoom(userInfo: UserInfo, lessonInfo: Lesson, zmClient: ZoomClient): Promise<void> {
    const session = zmClient.getSessionInfo();
    if (session && session.isInMeeting) {
      return;
    }
    const args = settingForDemo();

    const { name, password, topic, signature } = args;
    await zmClient.join(topic, signature, name, password).catch((e) => {
      console.log(e);
    });
  }
}
export const JoinService: new () => IJoinService = IS_DEMO ? JoinServiceDemo : JoinServiceApp;
